// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4x-0";
export var startPickingButton = "_4x-1";